import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bindAll } from '@bibliocommons/utils-react';
import FullScreenOverlay from '@bibliocommons/deprecated-base-full-screen-overlay';
import { ExpandableText } from '@bibliocommons/deprecated-expandable';
import { FormattedMessage } from 'react-intl';
import { bibShape, shelfItemShape, ugcQuotationShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { allowFreeText } from '@bibliocommons/utils-user';

import QuotationUGCEditor from '../UGCEditors/QuotationUGCEditor';
import DisplayWrapper from '../DisplayWrapper';
import DisplayActions from '../DisplayActions';

import './QuotationDisplay.scss';

export default class QuotationDisplay extends React.PureComponent {
  constructor(props) {
    super(props);
    bindAll(this);

    this.state = {
      showEditor: false
    };
  }

  openEditor() {
    this.setState({ showEditor: true });
  }

  closeEditor() {
    this.setState({ showEditor: false });
  }

  renderEditor() {
    return (
      this.state.showEditor && (
        <QuotationUGCEditor
          bib={this.props.bib}
          shelfItem={this.props.shelfItem}
          handleClose={this.closeEditor}
          existingQuotation={this.props.quotation}
          quotationsTransactions={this.props.quotationsTransactions}
          shelfTransactions={this.props.shelfTransactions}
          quotationsActions={this.props.quotationsActions}
          shelfActions={this.props.shelfActions}
        />
      )
    );
  }

  renderActions() {
    const { quotationsActions, quotationsTransactions, owner, quotation, bib } = this.props;

    if (owner.get('loggedIn')) {
      const quotationId = quotation.get('id');
      const metadataId = quotation.get('metadataId');
      const handleRemove = () => quotationsActions.removeQuotation({ metadataId, quotationId });
      const isRemoving = quotationsTransactions.getIn([metadataId, quotationId, 'isRemoving'], false);
      const title = bib.getIn(['briefInfo', 'title']);
      const editScreenReaderMessage = <FormattedMessage id="ada_ugc_edit_quotation" values={{ title }} />;
      const removeScreenReaderMessage = <FormattedMessage id="ada_ugc_remove_quotation" values={{ title }} />;

      return (
        <DisplayActions
          handleEdit={allowFreeText(owner) ? this.openEditor : undefined}
          handleRemove={handleRemove}
          isRemoving={isRemoving}
          editScreenReaderMessage={editScreenReaderMessage}
          removeScreenReaderMessage={removeScreenReaderMessage}
        />
      );
    }

    return null;
  }

  render() {
    return (
      <DisplayWrapper className="cp-ugc-quotation-display">
        <ExpandableText text={this.props.quotation.get('quotation')} />
        {this.renderActions()}

        <FullScreenOverlay open={!!this.state.showEditor} handleClose={this.closeEditor}>
          {this.renderEditor()}
        </FullScreenOverlay>
      </DisplayWrapper>
    );
  }
}

QuotationDisplay.propTypes = {
  bib: bibShape.isRequired,
  shelfItem: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  quotation: ugcQuotationShape.isRequired,
  quotationsTransactions: ImmutablePropTypes.map.isRequired,
  shelfTransactions: ImmutablePropTypes.map.isRequired,
  quotationsActions: PropTypes.objectOf(PropTypes.func).isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired
};
